import { EllipsisVerticalIcon } from "@heroicons/react/24/outline";
import { Dropdown, DropdownItem } from "./Dropdown";

// A table row's actions behind one "more" button. actions: [{ Icon, label, onClick }]; falsy entries are skipped
export default function RowMenu({ actions, label = "Actions" }) {
  return (
    <Dropdown
      fixed
      label={label}
      trigger={<EllipsisVerticalIcon className="h-5 w-5" />}
      triggerClassName="flex h-9 w-9 items-center justify-center rounded-md text-brand hover:bg-brand/10"
      panelClassName="min-w-44"
    >
      {actions.filter(Boolean).map(({ Icon, label: name, onClick }) => (
        <DropdownItem key={name} icon={<Icon className="h-4 w-4 text-slate-500" />} onClick={onClick}>
          {name}
        </DropdownItem>
      ))}
    </Dropdown>
  );
}
